/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Cookies from "js-cookie"

import Nav from "@components/nav"
import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import { AppContext } from "@src/context"
import LottieControl from "@src/components/lottie"
import loadingJson from "@images/lottieJson/loading.json"
import classnames from "@src/utils/classnames"
import { useRef } from "react"
import Prepare from "@src/components/prepare"
import config from "@config"
import { usePlayVideo } from "@src/utils/hooks"

const { pageUrl } = config

const APP_BREAKPOINT = 815.5
const Layout = ({ children, location }) => {
  const loadingRef = useRef(null)
  const [isAppLayout, setIsAppLayout] = useState(false)
  const [initialized, setInitialized] = useState(false)
  const [showBgVideo, setShowBgVideo] = useState(false)
  const bgVideoRef = useRef()
  usePlayVideo(bgVideoRef)

  const pathname = location?.pathname
  useEffect(() => {
    if (!pathname) {
      return
    }

    setShowBgVideo(!pathname.includes("streaming"))
  }, [pathname])

  useEffect(() => {
    const resizeEvent = () => {
      const winWidth = window.document.documentElement.clientWidth
      const isApp = winWidth <= APP_BREAKPOINT
      const htmlClassList = window.document.documentElement.classList
      if (isApp) {
        htmlClassList.add("is_app")
      } else {
        htmlClassList.remove("is_app")
      }
      setIsAppLayout(isApp)
    }
    resizeEvent()
    window.addEventListener("resize", resizeEvent)

    return () => {
      window.removeEventListener("resize", resizeEvent)
    }
  }, [])

  useEffect(() => {
    const loading = loadingRef.current
    if (!loading) {
      return
    }

    const visited = Cookies.get("visited")
    if (visited) {
      setTimeout(() => {
        setInitialized(true)
      }, 1500)
    } else {
      loadingRef.current.onComplete = () => {
        Cookies.set("visited", true, { expires: 365 })
        setInitialized(true)
      }
    }
  }, [])

  return (
    <AppContext.Provider value={{ isAppLayout, initialized }}>
      <img
        alt="share logo"
        src={`${pageUrl}share-logo.png?v=1`}
        className={classnames(styles.hiddenShareLogo)}
      />
      <div
        className={classnames(styles.bg, {
          [styles.hideBgVideo]: !showBgVideo,
        })}
      >
        <video
          src="https://site.gcores.com/assets/tdw2023/loop.mp4"
          ref={bgVideoRef}
          playsInline
          autoPlay
          loop
          muted
        />
      </div>
      <div
        className={classnames(styles.app, {
          [styles.appInitialized]: initialized,
        })}
      >
        <div
          className={classnames(styles.loadingContainer, {
            [styles.loadingCompleted]: initialized,
          })}
        >
          <div className={styles.loadingBox}>
            <LottieControl
              ref={loadingRef}
              animationData={loadingJson}
              className={styles.loading}
              config={{ loop: false }}
            />
          </div>
        </div>
        <Seo />
        <Nav location={location} />
        <div className={styles.container}>
          <main>{children}</main>
        </div>
      </div>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
